import Vue, { PluginObject } from 'vue';

export interface FormatterPlugin {
    formatNumber(num: number): string;

    formatBoolean(bool: boolean): string;

    formatInsured(bool: boolean): string;

    formatDate(date: Date): string;
}

export const Formatter: PluginObject<any> = {
    install(VueInstance) {
        const formatter: FormatterPlugin = {
            formatNumber: (num: number, fractionDigits = 0) => {
                if (num) {
                    return num.toFixed(fractionDigits).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1\'');
                }
                return '';
            },
            formatBoolean: (bool: boolean) => {
                return bool ? 'common.label.yes' : 'common.label.no';
            },
            formatInsured: (bool: boolean) => {
                return bool ? 'common.label.insured' : 'common.label.notInsured';
            },
            formatDate: (date: Date) => {
                return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
            },
        };

        VueInstance.filter('formatNumber', formatter.formatNumber);
        VueInstance.filter('formatBoolean', formatter.formatBoolean);
        VueInstance.filter('formatInsured', formatter.formatInsured);
        VueInstance.filter('formatDate', formatter.formatDate);
        VueInstance.$formatter = formatter;
        VueInstance.prototype.$formatter = formatter;
    },
};

Vue.use(Formatter);

